import {Panes, TextField} from '@management-ui/core';
import React from 'react';

const Fields = ({entity = {}, prefix = ''}) => {
  return (
    <Panes
      entity={entity}
      prefix={prefix}
      panes={[
        {
          title: '',
          fields: [
            <TextField
              name="name"
              prefix={prefix}
              label="Name"
            />,
            <TextField
              name="email"
              prefix={prefix}
              label="Email"
            />,
          ]
        }
      ]}
    />
  );
};

export default Fields;
